module.exports = __webpack_public_path__ + "static/img/downloaded_2_1.a4239df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq/downloaded_2_1.jpg
// module id = 2qwW
// module chunks = 1